import { useUser } from '@/hooks/auth';

export default function IsAdmin({ children }: { children: React.ReactNode }) {
    const user = useUser();
    if (!user || !user.role || user.role !== 'superadmin') {
        return null;
    }
    return <>{children}</>;
}
